import { useToolbarDragSurface } from '../../../hooks/use-toolbar-drag-surface'

/**
 * The quick tour's drag affordance, as panel chrome.
 *
 * Step 1 teaches dragging the panel, but the tour marks the panel's content
 * `inert`, and the header's toolbar row lives in that content. This strip is a
 * sibling of `[data-sidepanel-content]`, alongside the resize handles, so the
 * tour never reaches it.
 *
 * `top-3 h-12` mirrors the content's `p-3` padding and the toolbar row's `h-12`
 * height, landing the strip on the row the tour spotlights. It spans the full
 * root width on purpose: the side gutters are dead space during the tour, so
 * covering them just makes the target easier to grab.
 */
export function SidepanelTourDragStrip() {
  const onPointerDown = useToolbarDragSurface()

  return (
    <div
      aria-hidden
      onPointerDown={onPointerDown}
      className="pointer-events-auto absolute inset-x-0 top-3 h-12 cursor-grab select-none active:cursor-grabbing"
    />
  )
}
